module.exports = __webpack_public_path__ + "static/img/goods-100.d921b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-100.png
// module id = vuvo
// module chunks = 2